module.exports = __webpack_public_path__ + "img/274.ae3b08fa.png";